import * as eva from '@eva-design/eva';
import { ThemeType } from '@ui-kitten/components';
import { FontSource } from 'expo-font';

const Brands = require('../../../brands.json');

// Design system (mapping)
export const KalibraDesign = { ...eva };

// Theme objects (light/dark) from brands.json + Eva base
export const KalibraLightTheme: ThemeType = {
  ...eva.light,
  ...Brands.light_theme
};

export const KalibraDarkTheme: ThemeType = {
  ...eva.dark,
  ...Brands.dark_theme
};

// Font family sources for useFonts
export const KalibraFont: Record<string, FontSource> = {
  'Poppins-Regular': require('../../../assets/fonts/Poppins-Regular.ttf'),
  'Poppins-Medium': require('../../../assets/fonts/Poppins-Medium.ttf'),
  'Poppins-SemiBold': require('../../../assets/fonts/Poppins-SemiBold.ttf'),
  'Poppins-Bold': require('../../../assets/fonts/Poppins-Bold.ttf'),
  'Poppins-Italic': require('../../../assets/fonts/Poppins-Italic.ttf')
};
